import angular from 'angular';

import uiRouter from 'angular-ui-router';
import { name as ngstorage } from 'ngstorage';
import uiBootstrap from 'angular-ui-bootstrap';
import Common from './common/common';
import Components from './pages/components';
import Help from './help/help';
import AppComponent from './app.component';
import sessionExpirationModal from "./common/modals/sessionExpirationModal/sessionExpirationModal.component";
import ElementQueries from 'css-element-queries/src/ElementQueries';
import configureRoutes from './routes';


angular
  .module('app', [
    uiBootstrap,
    uiRouter,
    ngstorage,
    Common.name,
    Components.name,
    Help.name
  ])
  .config(($urlRouterProvider, $locationProvider, IdleProvider, toastrConfig, $stateProvider) => {
    'ngInject';
    $locationProvider.html5Mode(true);
    // configure Idle settings
    IdleProvider.idle(1800); // in seconds
    IdleProvider.interrupt("none");
    IdleProvider.timeout(30); // in seconds


    angular.extend(toastrConfig, {
      positionClass: 'toast-top-right',
      closeButton: true,
      timeOut: 1000,
      extendedTimeOut: 1000,
      tapToDismiss: true
    })

    console.log(toastrConfig);

    // Configure all application routes
    configureRoutes($stateProvider, $urlRouterProvider);
  })
  .config(function($sceDelegateProvider) {
    $sceDelegateProvider.resourceUrlWhitelist([
      // Allow same origin resource loads.
      'self',
      // Allow loading from our assets domain.  Notice the difference between * and **.
      API_HOST + '/api/**']);
    })
  .factory('Dropzone', () => Dropzone)
  .run(($rootScope, AuthenticationService, $state, $location, editableOptions, DTDefaultOptions, $cookies, Idle, $uibModal) => {
    'ngInject';

    let modalInstance;

    $rootScope.$on('IdleStart', function() {
      modalInstance = $uibModal.open(sessionExpirationModal);
      modalInstance.extendSession = function () {
        Idle.watch();
        modalInstance.dismiss();
      }
    });

    $rootScope.$on('IdleWarn', function(e, countdown) {
      modalInstance.countdown = countdown;
    });

    $rootScope.$on('IdleTimeout', function() {
      AuthenticationService.logout();
      modalInstance.dismiss();
    });

    DTDefaultOptions.setLoadingTemplate('<div class="v-middle"><div class="spinner" ><div class="rect1" style="margin-right: 2px"></div><div class="rect2" style="margin-right: 2px"></div><div class="rect3" style="margin-right: 2px"></div><div class="rect4" style="margin-right: 2px"></div><div class="rect5"></div></div></div>');

    editableOptions.theme = 'bs3'; // bootstrap3 theme. Can be also 'bs4', 'bs2', 'default'

    ElementQueries.listen();

    if ($location.search() && $location.search().error) {
      $state.go('login', { loginErrorCode: $location.search().error });
    }
  })
  .component('app', AppComponent);



// WEBPACK FOOTER //
// ./client/app.js